import { render, staticRenderFns } from "./bulk-messages-column.vue?vue&type=template&id=bf814c5e"
import script from "./bulk-messages-column.vue?vue&type=script&lang=js"
export * from "./bulk-messages-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf814c5e')) {
      api.createRecord('bf814c5e', component.options)
    } else {
      api.reload('bf814c5e', component.options)
    }
    module.hot.accept("./bulk-messages-column.vue?vue&type=template&id=bf814c5e", function () {
      api.rerender('bf814c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/columns/bulk-messages-column.vue"
export default component.exports